import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
// MatButtonModule and MatTooltipModule removed as we built custom accessible buttons
import { ThemeService } from '../../Services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
})
export class AvThemeToggleComponent {
  public themeService = inject(ThemeService);

  /**
   * Helper to check current mode state
   */
  isDark(): boolean {
    return this.themeService.mode() === 'dark';
  }

  /**
   * Toggles the theme between light and dark
   */
  toggle() {
    this.themeService.toggleMode();
  }

  /**
   * Explicitly sets the theme when clicking the icons
   * @param mode 'light' | 'dark'
   */
  setTheme(mode: 'light' | 'dark') {
    if (this.themeService.mode() !== mode) {
      this.themeService.toggleMode();
    }
  }
}